const weekdays = ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'];
export default function dateToDateAndWeekdayString(input: Date | string | number): string {
	const d = new Date(input);
	const year = d.getFullYear();
	const month = `${('0' + (d.getMonth() + 1)).slice(-2)}`;
	const date = `${('0' + d.getDate()).slice(-2)}`;
	const dayInWeekIndex = d.getDay();
	const dayInWeek = weekdays[dayInWeekIndex];

	return `${date}-${month}-${year} - ${dayInWeek}`;
}

